import { useCallback, useEffect, useMemo, useState } from "react";

const FULL_WIDTH_KEY = "affire-full-width-preference";

export const useMainLayout = () => {
  const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false);
  const [isFullWidth, setIsFullWidth] = useState(() => {
    // Load preference from localStorage
    const saved = localStorage.getItem(FULL_WIDTH_KEY);
    return saved === "true";
  });

  const toggleMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen((prev) => !prev);
  }, []);

  const closeMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen(false);
  }, []);

  const openMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen(true);
  }, []);

  const toggleFullWidth = useCallback(() => {
    setIsFullWidth((prev) => !prev);
  }, []);

  // Save preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem(FULL_WIDTH_KEY, String(isFullWidth));
  }, [isFullWidth]);

  return useMemo(
    () => ({
      isMobileNavigationOpen,
      toggleMobileNavigation,
      closeMobileNavigation,
      openMobileNavigation,
      isFullWidth,
      toggleFullWidth,
    }),
    [
      isMobileNavigationOpen,
      toggleMobileNavigation,
      closeMobileNavigation,
      openMobileNavigation,
      isFullWidth,
      toggleFullWidth,
    ],
  );
};
